import { Location } from '../../domain/models/locations/Location';
import { getSiteType } from '@pocapan/shared/utils/SiteTypes';

const LocationInformation = ({ pos }: { pos: Location }) => {
  const siteType = getSiteType(pos.siteType);
  return (
    <div className="flex space-x-3 px-4">
      <div>
        <div>
          <div className="flex flex-row items-center mt-3 text-main-light-4 dark:text-main-dark-4 text-[13px]">
            <img src={`/assets/icons/graphic-3d/${siteType.iconName}.png`} alt="category_icon" className="w-[14px] h-[14px] mb-[1px] mr-[4px]" />
            <span className="min-w-6">{siteType.name}</span>
            <span className="mx-[5px]">{' ･ '}</span>
            <span className="truncate">{pos.description}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LocationInformation;
